var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0306 9.28122C16.9609 9.35095 16.8782 9.40627 16.7871 9.44401C16.6961 9.48175 16.5985 9.50118 16.4999 9.50118C16.4014 9.50118 16.3038 9.48175 16.2127 9.44401C16.1217 9.40627 16.039 9.35095 15.9693 9.28122L8.99993 2.3109L2.03055 9.28122C1.88982 9.42195 1.69895 9.50101 1.49993 9.50101C1.30091 9.50101 1.11003 9.42195 0.969304 9.28122C0.828573 9.14048 0.749512 8.94961 0.749512 8.75059C0.749512 8.55157 0.828573 8.3607 0.969304 8.21996L8.4693 0.719965C8.53896 0.650232 8.62168 0.594914 8.71272 0.55717C8.80377 0.519427 8.90137 0.5 8.99993 0.5C9.09849 0.5 9.19608 0.519427 9.28713 0.55717C9.37818 0.594914 9.4609 0.650232 9.53055 0.719965L17.0306 8.21996C17.1003 8.28962 17.1556 8.37234 17.1933 8.46338C17.2311 8.55443 17.2505 8.65203 17.2505 8.75059C17.2505 8.84915 17.2311 8.94675 17.1933 9.0378C17.1556 9.12884 17.1003 9.21156 17.0306 9.28122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/ArrowTop.540129bd9e6eb422b669852eb2fec4c6.svg";
export { ForwardRef as ReactComponent };